import { colors } from '../../../../../colorVars';
import { LoadingIcon } from '../../icons/loadingIcon/LoadingIcon';
import style from './TextButton.module.css';

const loadingSizeMap = {
  'x-small': '20px',
  small: '25px',
  medium: '30px',
  large: '35px',
  'x-large': '40px',
};
const fontSizeMap = {
  'x-small': '0.579rem',
  small: '0.694rem',
  medium: '0.833rem',
  large: '1rem',
  'x-large': '1.2rem',
};
type Props = {
  children: string;
  backgroundColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  size: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
  fontColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  loading: boolean;
  clickHandler: () => void;
  dblClickHandler?: () => void;
  minWidth?: string;
  maxWidth?: string;
  disabled?: boolean;
  margin?: string;
};

export const TextButton = ({
  children,
  size,
  backgroundColor,
  fontColor,
  loading,
  clickHandler,
  dblClickHandler,
  minWidth,
  maxWidth,
  disabled,
  margin
}: Props) => {
  return (
    <button
      disabled={disabled}
      onClick={clickHandler}
      onDoubleClick={dblClickHandler}
      style={{
        margin,
        fontSize: fontSizeMap[size],
        backgroundColor: disabled ? 'grey' : colors[backgroundColor],
        borderColor: fontColor,
        color: loading ? colors[backgroundColor] : colors[fontColor],
        minWidth,
        maxWidth,
      }}
      className={disabled ? style.disabled : style.button}
    >
      {loading ? (
        <LoadingIcon size={loadingSizeMap[size]} color={fontColor} />
      ) : null}
      {children}
    </button>
  );
};
